export default __webpack_public_path__ + "static/media/button-emoji.34c397a0.svg";